import { layout } from '../app/'

import init from './init/'

export const start = ({ pages, features, priorities }) => {
  init({
    pages,
    layout,
    features,
    priorities
  })
}
